<template>
  <div class="container">
    <el-card header="General Data" shadow="never" class="card">
      <customize-form-info ref="generalData" :infoData="_generalData" />
    </el-card>
    <el-card header="CKR Plus Data" shadow="never" class="card">
      <p class="ckrDataFontSize">
        Credit Limit：{{
          this.$utils.formatAmount2(plusVO.creditLimitEstimate)
        }}
      </p>
      <p class="ckrDataFontSize">
        Revenue：{{ this.$utils.formatAmount2(plusVO.revenueValue) }}
      </p>
    </el-card>
    <el-card header="Scores" shadow="never" class="card">
      <template>
        <div class="part1">
          <div>
            <p style="margin-bottom: 15px">Commercial Score</p>
            <score-bar
              :scaleArr="[0, 25, 50, 75, 100]"
              :score="this.commercialScore"
            />
          </div>
          <div>
            <span>
              Company has a risk scale from "100" to "0", where grade 100
              represents
              <br />
              the lowest risk and grade 0 represents the highest risk .
            </span>
            <p>
              <span>Very low Risk (100 – 81)</span>
              <span>Low Risk ( 80 – 61)</span>
              <span>Normal Risk (60 – 41)</span>
              <span>Monitor Risk (40 – 21)</span>
              <span>Alert Risk (20 – 0)</span>
            </p>
          </div>
        </div>
        <!-- <div class="part2">
          <div>
            <p style="margin-bottom: 15px">Evjd Score</p>
            <score-bar
              :scaleArr="[0, 25, 50, 75, 100]"
              :score="this.evjdScore"
            />
          </div>
          <div>
            <span>
              This is a percentage of comparison between all debts and future
              judicial
              <br />
              credits of companies brought to present value (within the fiscal
              year).
              <br />
            </span>
            <span>
              This amount is compared to the company's revenue, and the
              percentage
              <br />
              shown in the result means how much of this revenue (gain) is
              committed
              <br />
              to lawsuits.
            </span>
          </div>
        </div> -->
      </template>
    </el-card>
    <el-card header="Corporate Control Of Capital" shadow="never" class="card">
      <customize-form-info ref="corporateData" :infoData="_corporateData" />
    </el-card>
    <el-card header="Partner" shadow="never" class="card">
      <el-table
        :data="detail.partnerVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in partnerSchema"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
      </el-table>
    </el-card>
    <el-card header="Tax Certificates" shadow="never" class="card">
      <el-table
        :data="detail.taxCertificatesVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in taxSchema"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
      </el-table>
      <div class="infoTxt">
        <p>Status Glossary:</p>
        <p>
          Negative - The company does not present debts referring to the scope
          consulted.
        </p>
        <p>
          Positive with negative effect - company is in regularization of debts
          referring to the scope consulted.
        </p>
        <p>
          Positive - The company presents debits related to the consulted scope.
        </p>
      </div>
    </el-card>
    <el-card header="Commercial Positive History" shadow="never" class="card">
      <el-table
        :data="detail.commercialPositiveHistoryVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          prop="periodDescription"
          label="Period"
          width="150"
        ></el-table-column>
        <el-table-column label="Quantity" align="center">
          <el-table-column
            label="From"
            prop="periodQuantityFrom"
          ></el-table-column>
          <el-table-column label="To" prop="periodQuantityTo"></el-table-column>
        </el-table-column>
        <el-table-column label="Quantity(%)" align="center">
          <el-table-column
            label="From"
            prop="percentageOfPeriodFrom"
          ></el-table-column>
          <el-table-column
            label="To"
            prop="percentageOfPeriodTo"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="Amount" align="center">
          <el-table-column
            label="From"
            prop="periodAmountsFrom"
          ></el-table-column>
          <el-table-column label="To" prop="periodAmountsTo"></el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card header="Business References" shadow="never" class="card">
      <el-table
        :data="this.detail.businessReferencesVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in businessSchema"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        ></el-table-column>
      </el-table>
    </el-card>
    <el-card header="Restrictive Summary" shadow="never" class="card font">
      <!-- <customize-form-info ref="restrictData" :infoData="_restrictData" /> -->
      <el-row>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Total Legal Events:</span>
          <span class="value">
            {{
              $utils.formatAmount(detail.restrictiveSummaryVO.totalLegalEvents)
            }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Number Of Protested Bills:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.numberOfProtestedBills }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Total Protests:</span>
          <span class="value">
            {{ $utils.formatAmount(detail.restrictiveSummaryVO.totalProtests) }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Number Of Execution Suits:</span>
          <span class="value">
            {{
                detail.restrictiveSummaryVO.numberOfExecutionSuits,
            }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Total Lawsuits Number:</span>
          <span class="value">
            {{
              $utils.formatAmount(
                detail.restrictiveSummaryVO.totalLawsuitsNumber,
              )
            }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Bill Sum Currency:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.billSumCurrency }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Search Date:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.pefinTotalSearchDate }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Supplier:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.pefinTotalSupplierStr }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Occurrences Phrase:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.pefinTotalOccurrencesPhraseStr }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Currency:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.pefinTotalCurrency }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Occurrences:</span>
          <span class="value">
            {{
                detail.restrictiveSummaryVO.pefinTotalOccurrences,
            }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Pefin Total Amount:</span>
          <span class="value">
            {{
              $utils.formatAmount(detail.restrictiveSummaryVO.pefinTotaLAmount)
            }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Num Of Returned Checks:</span>
          <span class="value">
            {{
              $utils.formatAmount(
                detail.restrictiveSummaryVO.numOfReturnedChecks,
              )
            }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Number Of SAS:</span>
          <span class="value">
            {{ $utils.formatAmount(detail.restrictiveSummaryVO.numberOfSas) }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Total Petitions:</span>
          <span class="value">
            {{ detail.restrictiveSummaryVO.totalPetitions }}
          </span>
        </el-col>
        <el-col class="_col" :xs="24" :sm="24" :md="11" :lg="8" :xl="8">
          <span class="key">Num Of Bankruptcy:</span>
          <span class="value">
            {{ detail.bankruptcyConcorDataVOS.length }}
          </span>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      header="Protests"
      shadow="never"
      class="card"
      v-if="detail.protestsVOS.length"
    >
      <p>
        Total number of protests:
        {{ detail.restrictiveSummaryVO.numberOfProtestedBills }} including
      </p>
      <p>
        The total value of protests is: {{ detail.protestsVOS[0].currency }}
        {{ $utils.formatAmount(detail.restrictiveSummaryVO.totalProtests) }}
      </p>
      <table width="100%">
        <tr
          class="tr"
          height="30px"
          style="background: #f5f5fa; line-height: 30px; text-align: left"
        >
          <td>Date</td>
          <td>Count</td>
          <td>Amout</td>
          <td>Location</td>
        </tr>
        <tr
          class="tr"
          style="line-height: 30px; text-align: left"
          v-for="(item, index) in detail.protestsVOS.slice(0, 5)"
          :key="index"
        >
          <td>{{ item.date }}</td>
          <td>{{ item.cartorio }}</td>
          <td>{{ item.currency }} {{ $utils.formatAmount(item.value) }}</td>
          <td>
            {{ item.city }},
            <span></span>
            {{ item.stateCode }}
          </td>
        </tr>
      </table>
    </el-card>
    <el-card
      header="Executive Lawsuits"
      shadow="never"
      class="card"
      v-if="detail.lawsuitVOS.length"
    >
      <p>
        Total number:
        {{
                detail.restrictiveSummaryVO.numberOfExecutionSuits,
        }}
        including
      </p>
      <p>
        Total Lawsuit Amount:
        {{
          $utils.formatAmount(detail.restrictiveSummaryVO.totalLawsuitsNumber)
        }},including
      </p>
      <table width="100%">
        <tr
          class="tr"
          height="30px"
          style="background: #f5f5fa; line-height: 30px; text-align: left"
        >
          <td>Date</td>
          <td>Origin</td>
          <td>Court</td>
          <td>Location</td>
        </tr>
        <tr
          class="tr"
          style="line-height: 30px; text-align: left"
          v-for="(item, index) in detail.lawsuitVOS.slice(0, 5)"
          :key="index"
        >
          <td>{{ item.date }}</td>
          <td>{{ item.origin }}</td>
          <td>{{ item.civilCourt }}</td>
          <td>
            {{ item.city }},
            <span></span>
            {{ item.stateCode }}
          </td>
        </tr>
      </table>
    </el-card>

    <el-card
      header="Financial Pending / Bank Refinancing"
      shadow="never"
      class="card"
      v-if="detail.pefinrefinVOS.length"
    >
      <p>
        Total number of Financial Pending / Bank Refinancing:
        {{
                detail.restrictiveSummaryVO.pefinTotalOccurrences,
        }}
      </p>
      <p>
        Total Lawsuit Amount of Financial Pending / Bank Refinancing:
        {{ $utils.formatAmount(detail.restrictiveSummaryVO.pefinTotaLAmount) }}
      </p>
      <el-table
        :data="detail.pefinrefinVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in pefinrefinVOSSchema"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
      </el-table>
    </el-card>
    <el-card shadow="never" class="card" header="Inquiries">
      <v-chart
        :options="options"
        ref="chart"
        style="width: 100%"
        v-if="detail.inquiriesVOS.length"
      />
    </el-card>
    <el-card
      header="Returned Checks"
      shadow="never"
      class="card"
      v-if="detail.checkCcfVOS.length"
    >
      <el-table
        :data="detail.checkCcfVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in checkCcfVOSSchema"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
      </el-table>
    </el-card>
    <el-card
      header="Bankruptcy"
      shadow="never"
      class="card"
      v-if="detail.bankruptcyConcorDataVOS.length"
    >
      <el-table
        :data="this.detail.bankruptcyConcorDataVOS.slice(0, 5)"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in bankruptcyConcorDataVOSSchema"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        ></el-table-column>
      </el-table>
    </el-card>

    <el-card shadow="never" class="card" header="Changes">
      <el-table
        :data="this.detail.historychangesChangesVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in changeSchema"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        ></el-table-column>
      </el-table>
    </el-card>
    <el-card header="Foundation History" shadow="never" class="card">
      <customize-form-info ref="generalData" :infoData="_foundationData" />
    </el-card>
    <el-card header="Administrative Board Details" shadow="never" class="card">
      <table width="100%">
        <tr
          class="tr"
          height="30px"
          style="background: #f5f5fa; line-height: 30px; text-align: left"
        >
          <td>Name</td>
          <td>Position</td>
          <td>Identification</td>
          <td>Additional Comments</td>
        </tr>
        <tr
          class="tr"
          style="line-height: 30px; text-align: left"
          v-for="(item, index) in detail.administrativeBoardDetailsVOS"
          :key="index"
        >
          <td>{{ item.firstName }} {{ item.lastName }}</td>
          <td>{{ item.titleStr }}</td>
          <td>{{ item.cpf }}</td>
          <td>
            {{ item.dailyActivities }}
          </td>
        </tr>
      </table>
    </el-card>
    <el-card header="Branch" shadow="never" class="card">
      <p>The subject maintains {{ detail.branchVOS.length }} branch(es)</p>
      <el-table
        :data="this.detail.branchVOS"
        style="width: 100%"
        :stripe="true"
        header-row-class-name="table-header"
      >
        <el-table-column
          v-for="item in branchSchema"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getCkrDetail } from '../../api'
import mixins from './mixins'
import ScoreBar from './components/score-bar'
export default {
  name: 'ckr-report',
  components: { ScoreBar },
  mixins: [mixins],
  data() {
    return {
      options: {
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0 },
          data: [],
        },
        yAxis: {
          type: 'value',
          interval: 1,
        },
        series: [
          {
            data: [],
            type: 'bar',
            color: '#409eff',
          },
        ],
        tooltip: {
          trigger: 'axis',
        },
      },
      detail: {},
      lawsuitVOSsum: 0,
      pefinrefinVOSsum: 0,
      protestsVOSList: [],
      commercialScore: 0,
      evjdScore: 0,
      pefinrefinVOSSchema: [
        { prop: 'dateFinancialPending', label: 'Date' },
        { prop: 'type', label: 'Type' },
        { prop: 'titleOcurrencePendingFinancialStr', label: 'Modality' },
        { prop: 'financialPendencyGuarantorStr', label: 'Guarantor' },
        { prop: 'currency', label: 'Coin' },
        { prop: 'financialPendencyValue', label: 'Amout' },
        { prop: 'financialPendencyContract', label: 'Contract' },
        { prop: 'financialPendencyOrigin', label: 'Source' },
      ],
      checkCcfVOSSchema: [
        { prop: 'dateOccurrence', label: 'Date Occurrence' },
        { prop: 'agency', label: 'Agency' },
        { prop: 'city', label: 'City' },
        { prop: 'stateCode', label: 'State Code' },
        { prop: 'typeStr', label: 'Check Type' },
      ],
      bankruptcyConcorDataVOSSchema: [
        { prop: 'date', label: 'Date' },
        { prop: 'type', label: 'Type' },
        { prop: 'origin', label: 'Origin' },
        { prop: 'civilCourt', label: 'Civil Court' },
        { prop: 'city', label: 'City' },
        { prop: 'stateCode', label: 'State Code' },
      ],
      partnerSchema: [
        { prop: 'firstName', label: 'First Name' },
        { prop: 'lastName', label: 'Last Name' },
        { prop: 'legalIdentification', label: 'Legal Identification' },
        { prop: 'legalName', label: 'Legal Name' },
        { prop: 'percentageCapital', label: 'Percentage Capital' },
      ],
      taxSchema: [
        { prop: 'certifacateName', label: 'Certificate Name' },
        {
          prop: 'certificateExpirationDate',
          label: 'Certificate Expiration Date',
        },
        { prop: 'certificateStatusStr', label: 'Certificate Status' },
      ],
      businessSchema: [
        { prop: 'businessDescription', label: 'Business Description' },
        { prop: 'valueFrom', label: 'Value From' },
        { prop: 'valueTo', label: 'Value To' },
        { prop: 'averageRangeValueFrom', label: 'Average Range Value From' },
        { prop: 'averageRangeValueTo', label: 'Average Range Value To' },
      ],
      inquireSchema: [
        { prop: 'inquiriesCnpj', label: 'Inquiries CNPJ' },
        { prop: 'inquiriesDate', label: 'Inquiries Date' },
        { prop: 'inquiriesName', label: 'Inquiries Name' },
        { prop: 'quantityInquiries', label: 'Quantity Inquiries' },
      ],
      changeSchema: [
        { prop: 'companyName', label: 'Company Name' },
        { prop: 'date', label: 'Date' },
        { prop: 'message', label: 'Message' },
      ],
      foundSchema: [
        { prop: 'firstSocialName', label: 'First Social Name' },
        { prop: 'foundationHeading', label: 'Foundation Heading' },
        { prop: 'date', label: 'Date' },
      ],
      branchSchema: [
        { prop: 'city', label: 'City' },
        { prop: 'countryStr', label: 'Country' },
        { prop: 'postalCode', label: 'Postal Code' },
        { prop: 'streetName', label: 'Street Name' },
        { prop: 'streetNumber', label: 'Street Number' },
        { prop: 'taxId', label: 'Tax Id' },
        { prop: 'telNumber', label: 'Tel Number' },
      ],
      plusVO: {},
    }
  },
  mounted() {
    this._getCkrDetail()
  },
  computed: {
    _generalData() {
      let _keys = []
      const _objData = {}
      if (this.detail.generalDataVO) {
        delete this.detail.generalDataVO.addressType
        delete this.detail.generalDataVO.addressTypeStr
        delete this.detail.generalDataVO.addressNumber
        delete this.detail.generalDataVO.addressName
        delete this.detail.generalDataVO.neighborhood
        delete this.detail.generalDataVO.city
        _keys = Object.keys(this.detail.generalDataVO)
        const _tempKey = _keys[1]
        _keys[1] = _keys[0]
        _keys[0] = _tempKey
        _keys.forEach(key => {
          _objData[key] = this.detail.generalDataVO[key]
        })
        _keys.forEach(key => {
          if (Object.prototype.hasOwnProperty.call(_objData, `${key}Str`)) {
            delete _objData[key]
          }
        })
      }
      return this.handleInfoData(_objData)
    },
    _corporateData() {
      this.detail.corporateControlOfCapitalVO &&
        Object.keys(this.detail.corporateControlOfCapitalVO).forEach(key => {
          if (
            Object.prototype.hasOwnProperty.call(
              this.detail.corporateControlOfCapitalVO,
              `${key}Str`,
            )
          ) {
            delete this.detail.corporateControlOfCapitalVO[key]
          }
        })
      return this.handleInfoData(this.detail.corporateControlOfCapitalVO)
    },
    _foundationData() {
      this.detail.foundationHistoryVO &&
        Object.keys(this.detail.foundationHistoryVO).forEach(key => {
          if (
            Object.prototype.hasOwnProperty.call(
              this.detail.foundationHistoryVO,
              `${key}Str`,
            )
          ) {
            delete this.detail.foundationHistoryVO[key]
          }
        })
      return this.handleInfoData(this.detail.foundationHistoryVO)
    },
  },
  methods: {
    async _getCkrDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.detail = await getCkrDetail(id)
        this.detail.bankruptcyConcorDataVOS.map(item => {
          switch (item.type) {
            case 'AF':
              item.type = 'Self bankruptcy required'
              break
            case 'DF':
              item.type = 'Bankruptcy request abandoned'
              break
            case 'EF':
              item.type = 'Extinction of bankruptcy liabilities'
              break
            case 'FD':
              item.type = 'Bankruptcy decreed'
              break
            case 'FR':
              item.type = 'Bankruptcy required'
              break
            case 'CD':
              item.type = 'Arrangement with creditors deferred'
              break
            case 'CR':
              item.type = 'Arrangement with creditors required'
              break
            case 'CS':
              item.type = 'Suspensive arrangement with creditors'
              break
            case 'DA':
              item.type = 'Extrajudicial arrangement with creditors abandoned'
              break
            case 'DC':
              item.type = 'Arrangement with creditors abandoned'
              break
            case 'EC':
              item.type =
                'Extrajudicial confirmation of arrangement with creditors'
              break
            case 'ED':
              item.type = 'Extrajudicial arrangement with creditors deferred'
              break
            case 'ER':
              item.type = 'Extrajudicial arrangement with creditors required'
              break
            case 'ES':
              item.type = 'Extrajudicial suspensive arrangement with creditors'
              break
            case 'HM':
              item.type = 'Confirmationofarrangement with creditors'
              break
          }
          switch (item.origin) {
            case '1':
              item.origin = 'Civil Court'
              break
            case '2':
              item.origin = 'Forum'
              break
            case '3':
              item.origin = 'Notary Public'
              break
            case '4':
              item.origin = 'Official correspondence'
              break
            case '5':
              item.origin = 'Titles and Document Registration Notary Public'
              break
            case '6':
              item.origin = 'RealEstateRegistrationNotary Public'
              break
            case '7':
              item.origin = 'Notary Public of Protests'
              break
            case '8':
              item.origin =
                'Legal Entity Titles and Document Registration Notary Public'
              break
            case '9':
              item.origin = 'Notary Public'
              break
          }
        })
        this.detail.administrativeBoardDetailsVOS.map(item => {
          switch (item.dailyActivities) {
            case '1':
              item.dailyActivities = 'Not active'
              break
            case '2':
              item.dailyActivities = 'Active'
              break
            case '3':
              item.dailyActivities = 'Active'
              break
            case '4':
              item.dailyActivities = 'Not active'
              break
            case '1a':
              item.dailyActivities = 'Not active'
              break
            case '2a':
              item.dailyActivities = 'Active'
              break
            case '3a':
              item.dailyActivities = 'Active'
              break
            case '4a':
              item.dailyActivities = 'Inactive'
              break
          }
        })
        this.plusVO = this.detail.plusVO
        // Inquiries柱形图
        const arr = []
        this.detail.inquiriesLastMonthlyVOS.map(item => {
          arr.push(item.recordData.slice(0, 7))
        })
        this.options.xAxis.data = arr
        this.options.series[0].data = this.detail.inquiriesLastMonthlyVOS.map(
          item => item.quantityConsults,
        )

        this.detail.lawsuitVOS.forEach(item => {
          this.lawsuitVOSsum += Number(item.value)
        })
        this.detail.pefinrefinVOS.forEach(item => {
          this.pefinrefinVOSsum += Number(item.financialPendencyValue)
        })
        for (let val in this.detail.businessReferencesVOS) {
          const filterArData = [
            'averageRangeValueFrom',
            'averageRangeValueTo',
            'valueFrom',
            'valueTo',
          ]
          filterArData.forEach(key => {
            const value = this.detail.businessReferencesVOS[val][key]
            this.detail.businessReferencesVOS[val][key] =
              this.$utils.formatAmount(value)
          })
        }
        for (let key in this.detail.commercialPositiveHistoryVOS) {
          this.detail.commercialPositiveHistoryVOS[key].periodAmountsTo =
            this.$utils.formatAmount(
              this.detail.commercialPositiveHistoryVOS[key].periodAmountsTo,
            )
          this.detail.commercialPositiveHistoryVOS[key].periodAmountsFrom =
            this.$utils.formatAmount(
              this.detail.commercialPositiveHistoryVOS[key].periodAmountsFrom,
            )
        }
        this.detail.corporateControlOfCapitalVO.socialCapitalValue =
          this.$utils.formatAmount(
            this.detail.corporateControlOfCapitalVO.socialCapitalValue,
          )
        this.commercialScore = Number(
          this.detail.scoresVO && this.detail.scoresVO.commercialScore,
        )
        this.evjdScore = Number(
          this.detail.scoresVO && this.detail.scoresVO.evjdScore,
        )
      } catch (err) {
        console.error(err)
      }
    },
    handleInfoData(apiData) {
      if (apiData) {
        return Object.keys(apiData).map(key => ({
          key: mixins.methods.transKeyToLabel(key),
          value: apiData[key],
        }))
      }
      return []
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  .font {
    ._col {
      margin-bottom: 12px;
    }
    .key {
      font-size: 14px;
      margin-right: 12px;
    }
    .value {
      font-size: 14px;
    }
  }
  .card {
    width: 100%;
    margin-bottom: 24px;
    p {
      height: 30px;
    }
    .part1 {
      display: flex;
      font-size: 14px;
      & > div {
        width: 50%;
      }
      & > div:nth-child(2) {
        box-sizing: border-box;
        margin-left: 90px;
        & > p:nth-child(2) {
          margin-top: 6px;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .part2 {
      margin-top: 20px;
      font-size: 14px;
      display: flex;
      & > div {
        width: 50%;
      }
      & > div:nth-child(2) {
        box-sizing: border-box;
        margin-left: 90px;
      }
    }
    :deep(.table-header) {
      th {
        background-color: #f5f5fa;
        height: 56px;
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
    }
    .infoTxt {
      margin-top: 10px;
      & > p:first-child {
        font-size: 14px;
        margin-bottom: 8px;
      }
      & > p {
        font-size: 12px;
      }
    }
  }
  .tr {
    display: flex;
    td {
      justify-content: space-around;
      width: 25%;
      font-size: 14px;
      padding-left: 15px;
    }
  }
  .tr1 {
    font-size: 14px;
    td {
      width: 20%;
    }
  }
  .ckrDataFontSize {
    font-size: 14px;
  }
}
</style>
